<template>
    <div class="global-single-box">
        <div class="global-single-switch">
            <a-radio-group v-model="value" button-style="solid">
                <a-radio-button :value="$t('edit.settings.setsTitle')">
                    {{$t('edit.settings.setsTitle')}}
                </a-radio-button>
                <a-radio-button :value="$t('edit.settings.singleSenceTitle')">
                    {{$t('edit.settings.singleSenceTitle')}}
                </a-radio-button>
            </a-radio-group>
        </div>
        <div class="global-single-content">
            <div class="global-content" v-if="value == $t('edit.settings.setsTitle')">
                <slot name="global"></slot>
            </div>
            <div class="single-content" v-else>
                <slot name="single"></slot>
            </div>
        </div>
        <!--        <div class="hr"></div>-->
        <div class="global-single-btns" v-if="footer">
            <a-button type="primary" @click="handleSubmit">
                {{ $t('actionTitles.submit')}}
            </a-button>
            <a-button style="margin-left: 10px;" @click="handleCancel">{{ $t('actionTitles.cancel') }}</a-button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "GlobalSingle",
    props: {
        footer: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            value: this.$t('edit.settings.setsTitle'),
        };
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    methods: {
        handleSubmit() {
            this.$emit("handleSubmit");
        },
        handleCancel() {
            this.$emit('handleCancel')
        },
    },
}
</script>

<style lang="less" scoped>
.global-single-box {
    height: 100%;
    max-width: 1200px;
}

.global-single-switch {
    display: flex;
    margin-bottom: 20px;
}

.global-single-content {
    padding-right: 10px;
    height: calc(100% - 120px);
    overflow-y: auto;
}

.hr {
    width: 100%;
    height: 2px;
    border-top: 1px solid #000000;
    border-bottom: 1px solid #4b4b4b;
    margin: 30px 0;
}

.global-single-btns {
    margin-top: 30px;

    .submitBtn {
        background-color: #7101ad;
        border-color: #7101ad;
    }
}
</style>
